import React, { Component } from 'react';
import { Field } from 'formik';
import { Form, Button, Grid } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import styled from 'styled-components';
import { HHFileUploader } from './fields';
import HHImageTemplates from './fields/hhImageTemplates';
import Image from '../common/image';
import CreateEventQuitModal from '../events/components/createEventQuitModal';

const FormHeader = styled.div`
  font-family: 'Inter';
  font-weight: 900;
  font-size: 24px;
  line-height: 29.05px;
  font-style: normal;
  color: #333333;
  padding-bottom: 10px;
`;

const FieldsHelpText = styled.p`
  color: #A4A4A4;
  font-family: 'Inter';
  font-weight: 500;
  font-size: 14px;
  line-height: 16.94px;
  padding-bottom: 8px;
`;

const FieldsHeaderText = styled.p`
  display: inline-block;
  font-family: 'Inter';
  font-size: 24px;
  line-height: 29.05px;
  font-weight: 600;
  color: #333333;
  padding-bottom: 10px;
`;

class EventFormImage extends Component {
  saveAndContinue = e => {
    e.preventDefault();
    this.props.nextStep(3);
  };
  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    const {
      values, translate, currentBannerBg, currentCoverImageUrl, user
    } = this.props;

    return (
      <div className='create-event-container'>
        <CreateEventQuitModal />
        <Form className='cms-create-event-form'>
          <div className='create-event-form-header'>
            <FormHeader>
              {translate('createEvent.form.header.page')}
            </FormHeader>
            <FieldsHelpText>
              {translate('eventDesignInstruction')}
            </FieldsHelpText>
          </div>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column className='imageLeft'>
                <section >
                  <Form.Field className='bannerImage'>
                    <FieldsHeaderText>
                      {translate('banner.image')}
                    </FieldsHeaderText>
                    <FieldsHelpText>
                      {translate('banner.image.instruction')}
                    </FieldsHelpText>
                    <Field
                      name='bannerBg'
                      component={HHFileUploader}
                      otherProps={{
                      id: 'form-bannerBg',
                      type: 'image_37x9',
                      fileType: 'event_banner',
                      slug: values.slug,
                      userToken: user.token,
                      trigger: (
                        <Image
                          id='bannerBgTrigger'
                          src={currentBannerBg}
                          alt='uploaded file'
                        />
                      )
                    }}
                    />
                  </Form.Field>
                </section>
              </Grid.Column>

              <Grid.Column className='imageRight'>
                <section >
                  <Form.Field className='coverImage'>
                    <FieldsHeaderText>
                      {translate('cover.image')}
                    </FieldsHeaderText>
                    <FieldsHelpText>
                      {translate('cover.image.instruction')}
                    </FieldsHelpText>
                    <Field
                      name='coverImageUrl'
                      component={HHFileUploader}
                      otherProps={{
                        id: 'form-coverImageUrl',
                        type: 'image_16x9',
                        fileType: 'event_cover',
                        slug: values.slug,
                        userToken: user.token,
                        trigger: (
                          <Image
                            id='coverImgTrigger'
                            src={currentCoverImageUrl}
                            alt='uploaded file'
                          />
                        )
                      }}
                    />

                  </Form.Field>
                </section>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column className='imageLeft'>
                <section >
                  <Form.Field
                    className='bannerImageTemplates'
                  >
                    <FieldsHelpText>{translate('eventImageTemplateInstruction')}</FieldsHelpText>
                    <Field
                      name='bannerBg'
                      component={HHImageTemplates}
                    />
                  </Form.Field>
                </section>
              </Grid.Column>

              <Grid.Column className='imageRight'>
                <section >
                  <Form.Field className='coverImageTemplates'>
                    <FieldsHelpText>{translate('eventImageTemplateInstruction')}</FieldsHelpText>
                    <Field
                      name='coverImageUrl'
                      component={HHImageTemplates}
                    />
                  </Form.Field>
                </section>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <div className='prevBtn'>
            <Button onClick={this.back}>
              {translate('createEvent.backBtn.page')}
            </Button>
          </div>
          <div className='nextBtn'>
            <Button onClick={this.saveAndContinue}>
              {translate('createEvent.nextBtn.page')}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

export default withLocalize(EventFormImage);



// WEBPACK FOOTER //
// ./src/components/forms/eventFormImage.js